var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.classes,style:(Object.assign({}, _vm.computedFlexPosition)),on:{"mousedown":_vm.handleSwitch}},[_c('div',{staticClass:"switch-wrapper",style:({
      width: _vm.computedSwitchWidth,
      height: _vm.computedSwitchHeight,
      padding: _vm.computedSwitchPadding,
    }),on:{"mouseenter":_vm.handleHoverEnter,"mouseleave":_vm.handleHoverLeave}},[_c('div',{staticClass:"thumb-wrapper",style:({
        background: _vm.computedHaloColor,
        transform: _vm.computeThumbTransform,
        padding: _vm.computedThumbHaloRadius,
        top: _vm.computedThumbTop,
      }),on:{"mousedown":_vm.handleClickThumb}},[_c('div',{staticClass:"thumb",style:({
          background: _vm.computedThumbColor,
          width: _vm.computedThumbSize,
          height: _vm.computedThumbSize,
        })})]),_c('div',{staticClass:"track",style:(Object.assign({}, _vm.computedTrackColor, {borderRadius: _vm.computedTrackRadius}))})]),_c('div',{staticClass:"label-wrapper"},[_c('span',{style:({ color: _vm.computedLabelText })},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }